import { TrustpilotWidget } from "web/script/analytics/third_party_scripts/trustpilot-widget";

/**
 *
 * When new third party scripts are added that also create new
 * cookies then that cookie version will need to be incremented
 * in src/ssaw/utils/constants/cookie_consent.py.
 * This will invalidate older cookies and require renewed consent
 * from the user.
 *
 */
export type CookieType = "essential" | "analytics" | "customization" | "advertisement";
export interface ThirdPartyScript {
    load(): Promise<void>;
    cookieType: CookieType;
}

export default [new TrustpilotWidget()];
